import { render, staticRenderFns } from "./TrooperzFull.vue?vue&type=template&id=1c078a15&"
import script from "./TrooperzFull.vue?vue&type=script&lang=ts&"
export * from "./TrooperzFull.vue?vue&type=script&lang=ts&"
import style0 from "./TrooperzFull.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports